<template>
  <Popper
      arrow
      :hover="true"
  >
    <template #content>
      <div class="hover">
        <div style="width: fit-content; white-space: nowrap">{{ label.label }}</div>
        <div v-if="this.type === 'E' && label.daysDiff > -1" style="width: fit-content; white-space: nowrap">
          <i class="ri-sun-line" v-if="data.releaseTime === 'bmo'"/>
          <i class="ri-moon-line" v-else/>
          {{ dictionary.calendars.labels[data.releaseTime === 'bmo' ? 'preMarket' : 'afterMarket'] }}
        </div>

        <div v-if="this.type === 'T'" style="width: fit-content; white-space: nowrap">
          <i class="ri-group-line"/>
          {{ dictionary.trendingStocks.label }}
        </div>

      </div>
    </template>
    <div class="tagLabel" :class="{full}" :theme="systemTheme" v-if="!full">
      {{ type }}
    </div>
    <div class="tagLabel" :class="{full}" :theme="systemTheme" v-else>
              <i class="ri-calendar-line"/> &nbsp;
      {{ label.label }}
    </div>
  </Popper>
</template>

<script>
import {DateTime} from 'luxon';
import Popper from "vue3-popper";

export default {
  name: "symbolTagLabel",
  props: ['data', 'type', 'full'],
  components: {Popper},
  computed: {
    label() {
      if (!this.data) return {label: null, daysDiff: null};
      const inputDate = DateTime.fromISO(this.data.date || this.data.paymentDate).startOf('day');
      const today = DateTime.local().startOf('day');

      if (['E', 'S', 'D'].includes(this.type)) {

        if (this.systemLanguage === 'en') {
          let eventLabel = this.type === 'E' ? 'Earnings report' : this.type === 'S' ? 'Stock split' : 'Dividends';
          let diffLabel = '';

          const diff = inputDate.diff(today, 'days').toObject().days;
          if (diff === 0) diffLabel = 'today';
          if (diff === 1) diffLabel = 'tomorrow';
          if (diff > 1) diffLabel = `in ${Math.round(diff)} days`;
          if (diff === -1) diffLabel = `yesterday`;
          if (diff < -1) diffLabel = `${Math.round(diff)} days ago`;

          let label = `${eventLabel} ${diffLabel}`;
          if (this.data.amount) label += `: $${this.data.amount}`
          if (this.data.ratio) label += ` by a ratio of ${this.data.ratio}`
          if (this.data.epsEstimate) label += ` (EPS est. $${this.data.epsEstimate})`


          return {label, daysDiff: Math.round(diff) }

        } else if (this.systemLanguage === 'he') {

          let eventLabel = this.type === 'E' ? 'דו״ח רווחים' : this.type === 'S' ? 'פיצול מניה' : 'חלוקת דיבידנד';
          let diffLabel = '';


          const diff = inputDate.diff(today, 'days').toObject().days;
          if (diff === 0) diffLabel = 'היום';
          if (diff === 1) diffLabel = 'היום';
          if (diff === -1) diffLabel = 'אתמול';
          if (diff > 1) diffLabel = `בעוד ${Math.round(diff)} ימים`;
          if (diff < -1) diffLabel = `לפני ${Math.round(diff)} ימים`;

          let label = `${eventLabel} ${diffLabel}`;
          if (this.data.amount) label += `: $${this.data.amount}`
          if (this.data.ratio) label += ` ביחס של ${this.data.ratio}`
          if (this.data.epsEstimate) label += ` (הערכה: $${this.data.epsEstimate})`

          return {label, daysDiff: Math.round(diff) }
        }
      } else if (this.type === 'T') {
        return {label: this.systemLanguage === 'en' ? 'Trending on social media' : 'טרנדית ברשתות החברתיות'}
      }
    }
  }
}
</script>

<style scoped lang="scss">

.tagLabel {
  background: var(--lightYellow);
  width: 22px;
  height: 22px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  cursor: pointer;
  z-index: 99999;
    color: var(--bgColor);
  &[theme="lightMode"] {
    color: var(--bgColor);
  }
}

.full {
  width: fit-content;
  height: fit-content;
  padding: 5px 10px;
}

.hover {
  display: flex;
  align-items: center;
  z-index: 999999999;
  gap: 15px;
}


</style>
